const PropTypes = require('prop-types');
/**
 * Created by adderlyjaureguicampos on 08/12/16.
 */
const React = require("react");

const {formatText} = require('core/i18n').i18n;
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const ThirdPartyTransitionalFunds = require('../ThirdPartyTransitionalFunds/ThirdPartyTransitionalFunds');
const mockHelper = require('../../../utilities/mockDataHelper');
const formHelper = require('../../../utilities/formHelper');

class OwnMoneyAccount extends React.Component {

    constructor(props) {
        let initialState;
        super(props);
        if (this.props.values) {
            initialState = {
                isOwnMoneyAccount: this.props.values.isOwnMoneyAccount,
                thirdPartyTransitionalFunds: this.props.values.thirdPartyTransitionalFunds,
                component_id: 'ownMoneySelect'
            }
        } else {
            initialState = {
                isOwnMoneyAccount: null,
                thirdPartyTransitionalFunds: null,
                component_id: 'ownMoneySelect'
            };
        }
        this.state = initialState;
        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.onThirdPartyTransitionalFundsChange = this.onThirdPartyTransitionalFundsChange.bind(this);
        this.thirdPartyTransitionalFundsRadioOptions = mockHelper.mockThirdPartyTransitionalFunds();
        this.buildRadioGroup = this.buildRadioGroup.bind(this);

    }


    onThirdPartyTransitionalFundsChange(event) {
        event = formHelper.stringToBoolean(event);
        this.setState({
            thirdPartyTransitionalFunds: event
        });
    }

    buildRadioButton(radioButton) {
        return (<RadioButton
            label={radioButton.label}
            value={radioButton.value}
            className="block-step__radio"/>);
    }

    buildRadioGroup(radioOptions) {
        return (
            <RadioButtonGroup
                name="ownMoney"
                idPrefix="ownMoneySelected"
                selectedValue={this.state.isOwnMoneyAccount}
                className="block-step__radio-group"
                onChange={this.handleRadioButtonChange}>
                {radioOptions}
            </RadioButtonGroup>
        );
    }

    handleRadioButtonChange(event) {
        event = formHelper.stringToBoolean(event);
        if (event) {
            this.setState({
                isOwnMoneyAccount: event,
                thirdPartyTransitionalFunds: null
            });
        }
        this.setState({
            isOwnMoneyAccount: event
        });
    }


    showThirdPartyTransitionalFunds() {
        if (this.state.isOwnMoneyAccount != null) {
            if (!this.state.isOwnMoneyAccount ) {
                return (<ThirdPartyTransitionalFunds
                    type="single"
                    selectedValue={this.state.thirdPartyTransitionalFunds}
                    handleRadioButtonChange={this.onThirdPartyTransitionalFundsChange}
                    radioOptions={this.thirdPartyTransitionalFundsRadioOptions}/>)
            } else {
                return null;
            }
        }

    }

    render() {
        this.props.dataReceiver(this.state);
        let radioOptions = [];
        this.props.radioOptions.forEach(option => {
            radioOptions.push(this.buildRadioButton(option));
        });
        switch (this.props.type) {
            case 'single':
                return (
                    <div className="tax-data">
                        <div
                            className="ok-slider__text">{formatText('contractsView-checkingAccountOwmMoneyAccountFirstRadioGroupTitle')}</div>
                        {this.buildRadioGroup(radioOptions)}
                        <div>
                            {this.showThirdPartyTransitionalFunds()}
                        </div>
                    </div>);
            case 'form':
                return (
                    <div className="tax-data">
                        <div
                            className="ok-slider__text">{formatText('contractsView-checkingAccountOwmMoneyAccountSecondRadioGroupTitle')}</div>
                        <div className="ok-slider__slider-box">
                            {this.buildRadioGroup(radioOptions)}
                            <div>
                                {this.showThirdPartyTransitionalFunds()}
                            </div>

                        </div>
                    </div>
                )
        }
    }
}

OwnMoneyAccount.propTypes = {
    type: PropTypes.string,
    radioOptions: PropTypes.array,
    dataReceiver: PropTypes.func,
    values: PropTypes.any
};

module.exports = OwnMoneyAccount;